import { extendTheme } from "@chakra-ui/react";
import { ButtonStyle as Button } from "./Components/ButtonStyles";

export const appTheme = extendTheme({
    colors: {
        primary: "#0095C8",
        primaryDark: "#016293",
        secondary: "#809CFF",
        secondaryPurple: "#937CE6",
        secondaryPink: "#F24C96",
        darkBg: "#293452",
        darkBgAlt: "#2F3859",
        lightBgAlt: "#E9FFFF",
        white: "#FFFFFF",
    },
    fonts: {
        heading: "'Public Sans', sans-serif",
        body: "'Inter', sans-serif",
    },
    components: {
        Button
    }
})
